import * as React from 'react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getActiveUser, impersonate } from '../../api/adminClientApi';
import { LoadingPageOverlay } from '../../designSystem/LoadingPageOverlay';
import { Flex } from '../../designSystem/compositeComponents/FlexHelpers';
import { Button } from '../../designSystem/button/Button';
import { TextField } from '../../designSystem/formField/text/TextField';
import { MessageCard } from '../../designSystem/Message';
import { SingleColumnLayout } from '../../designSystem/layouts/SingleColumnLayout';
import { AmorgAdminPageProvider } from './AmorgAdminPageContext';
import { AdminTab } from './_components/AdminTab';

export default function AmorgAdminSiteLogin (): JSX.Element 
{
    const history = useHistory();

    const [loading, setLoading] = React.useState(true);
    const [site, setSite] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [didSubmit, setDidSubmit] = React.useState(false);

    useEffect(() =>
    {
        const init = async () =>
        {
            await getActiveUser(() => history.push(`/amorgy/login`));
            setLoading(false);
        };
        init().catch(console.error);
    }, []);

    async function handleClickLogin ()
    {
        setLoading(true);
        const {landingUrl} = await impersonate(site, email);
        history.push(landingUrl);

        // If we make it here, we weren't redirected and thus were unsuccessful
        setLoading(false);
        setDidSubmit(true);
    }

    return (

        <AmorgAdminPageProvider>
            <LoadingPageOverlay loading={loading} />

            <SingleColumnLayout
                noDivider
                headerContainer={
                    <Flex flexDirection="column" gap={16}>
                        <AdminTab selectedTab='sitelogin' />
                    </Flex>
                }

                contentContainer={
                    <Flex justifyContent='center'>
                        <Flex flexDirection='column' gap={16} style={{ maxWidth: '600px', flexGrow: 1 }}>
                            {didSubmit &&
                                <MessageCard variant='warning'>
                                    Ugyldigt login
                                </MessageCard>
                            }
                            <TextField
                                value={site}
                                onChange={setSite}
                                label={'Organisation'}
                                validator={() => ({ valid: true })}
                            />

                            <TextField
                                value={email}
                                onChange={setEmail}
                                label={'Email'}
                                validator={() => ({ valid: true })}
                            />
                            <Flex justifyContent='flex-end'>
                                <Button variant='filled' icon="login" text="Log ind" onClick={handleClickLogin} />
                            </Flex>
                        </Flex>
                    </Flex>
                }

            />
        </AmorgAdminPageProvider>
    );
}